import { forwardRef } from "react";
import { CoreCurrencyInput } from "@boi/components-core";

import { NumberInput, type NumberInputProps } from "../NumberInput";

export type CurrencyInputProps = Omit<
  NumberInputProps,
  "startSlot" | "formatOptions"
> & {
  currencySymbol?: string;
  currencyFormat?: CoreCurrencyInput.CurrencyFormat;
};

const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  (props, ref) => {
    const {
      currencySymbol = CoreCurrencyInput.DEFAULT_SYMBOL,
      currencyFormat = CoreCurrencyInput.DEFAULT_DECIMAL_PLACES,
      testID = "currency-input",
      ...otherProps
    } = props;

    const formatOptions =
      currencyFormat === CoreCurrencyInput.TWO_DECIMAL_PLACES
        ? CoreCurrencyInput.TWO_DP_FORMAT_OPTIONS
        : CoreCurrencyInput.ZERO_DP_FORMAT_OPTIONS;

    return (
      <NumberInput
        {...otherProps}
        ref={ref}
        startSlot={currencySymbol}
        formatOptions={formatOptions}
        testID={testID}
      />
    );
  }
);

CurrencyInput.displayName = "CurrencyInput";

export default CurrencyInput;
